/**
 * @desc 导出详情
 */
const URL = "/rantion-rms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  body: defs.rms.ExpenseReimbursementRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/expenseReimbursement/exportExpenseReimbursement`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
